import _ from 'lodash';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { CheckMark, CheckMarkTypes } from '../CheckMark';

enum PatientOrCustom {
  Patient = 'PATIENT',
  Custom = 'CUSTOM',
}

const BASE_ITEMS = ['id', 'created', 'updated'];

interface Props<T> extends WithTranslation {
  value: T;
  patientValue?: T;
  customInputRender: (isDisabled: boolean) => React.ReactNode;
  customElementName: string;
  onSameAsPatientClicked: () => void;
}

interface State {
  selected: PatientOrCustom | null;
}

class SameAsPatientOrCustom<T> extends React.Component<Props<T>, State> {
  state: State = {
    selected: null,
  };

  componentDidMount() {
    if (!this.props.value) return;
    if (!this.props.patientValue) return;

    if (
      _.isEqual(
        _.omit(this.props.value, BASE_ITEMS),
        _.omit(this.props.patientValue, BASE_ITEMS),
      )
    ) {
      this.setState({ selected: PatientOrCustom.Patient });
    } else {
      this.setState({ selected: PatientOrCustom.Custom });
    }
  }

  render() {
    const {
      customElementName,
      customInputRender,
      onSameAsPatientClicked,
      patientValue,
      t,
    } = this.props;
    const { selected } = this.state;

    if (!patientValue) {
      return customInputRender(false);
    }
    return (
      <div>
        <CheckMark
          type={CheckMarkTypes.RADIO}
          checked={selected === PatientOrCustom.Patient}
          label={t('Same as patient')}
          onClick={() => {
            this.setState({ selected: PatientOrCustom.Patient });
            onSameAsPatientClicked();
          }}
        />
        <CheckMark
          type={CheckMarkTypes.RADIO}
          checked={selected === PatientOrCustom.Custom}
          label={t(`Use a different ${customElementName}`)}
          onClick={() => {
            this.setState({ selected: PatientOrCustom.Custom });
          }}
        />
        {selected !== null &&
          customInputRender(selected === PatientOrCustom.Patient)}
      </div>
    );
  }
}

export default withTranslation()(SameAsPatientOrCustom);
